import React from "react";
import { createPortal } from "react-dom";

import { Button, Icon } from "../../components/ui";
import { SelectedRequestsTray } from "./SelectedRequestsTray";
import { useRequestLookbook } from "./useRequestLookbook";

/** The bar that announces select mode, and the selected-requests tray. */
export const RequestLookbookBar = () => {
  const { isEditing, cancel, error, hydrating } = useRequestLookbook();

  return (
    <div className="rlb-bar-wrap">
      <div className="rlb-bar">
        <div className="rlb-bar__text">
          <span className="rlb-bar__title">
            {isEditing ? "Editing lookbook" : "New lookbook"}
          </span>
          <span className="rlb-bar__hint">
            Tick to add — filters and search still work. Drag to set the PDF
            order.
          </span>
        </div>

        <Button
          variant="secondary"
          onClick={cancel}
          leadingIcon={<Icon name="X" size="xs" />}
        >
          Cancel
        </Button>
      </div>

      {error && <div className="rlb-bar__error">{error}</div>}

      {hydrating ? (
        <div className="rlb-tray rlb-tray--empty">
          <p className="rlb-tray__empty-title">Loading this lookbook…</p>
        </div>
      ) : (
        <SelectedRequestsTray />
      )}
    </div>
  );
};

/** Fixed bottom-centre dock: how many are picked, and the way forward. */
export const RequestLookbookDock = () => {
  const { count, canProceed, openAmounts } = useRequestLookbook();

  return createPortal(
    <div className="rlb-dock" role="status">
      <span className="rlb-dock__badge">{count}</span>
      <span className="rlb-dock__label">
        {count === 1 ? "request selected" : "requests selected"}
      </span>
      <Button size="lg" disabled={!canProceed} onClick={openAmounts}>
        Proceed
      </Button>
    </div>,
    document.body
  );
};
